import { MiniLockup } from "./Logos";
import type { Track } from "./Hero";

// Shared page chrome for both wizards.

export function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-brand-bg">
      <div className="bg-brand-navy">
        <div className="mx-auto max-w-3xl px-4 md:px-6 py-4 flex items-center justify-center">
          <MiniLockup />
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-6 md:py-10">{children}</div>
    </div>
  );
}

export function WizardHeader({ track }: { track: Track }) {
  return (
    <header>
      <div className="text-[12px] uppercase tracking-[0.18em] font-bold text-brand-teal">
        {track === "advisor"
          ? "Advisors, supporting companies"
          : track === "mentor"
            ? "Mentors, supporting individuals"
            : "Advisors and Mentors, supporting both"}
      </div>
      <h1 className="mt-2 font-bold text-[24px] md:text-[30px] leading-tight text-brand-navy">
        A few details so we can match you well.
      </h1>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="mt-10 text-center text-[12px] text-brand-mute">
      Trouble submitting? Email{" "}
      <a className="text-brand-teal underline" href="mailto:elevate@gazaskygeeks.com">
        elevate@gazaskygeeks.com
      </a>
      .
    </footer>
  );
}

export function SectionHeading({ title, sub }: { title: string; sub: string }) {
  return (
    <div>
      <h2 className="text-[22px] font-bold text-brand-navy">{title}</h2>
      <p className="mt-1 text-[14px] text-brand-mute leading-relaxed">{sub}</p>
    </div>
  );
}

export function SuccessPage({ track }: { track: Track }) {
  return (
    <div className="min-h-screen bg-brand-bg">
      <div className="mx-auto max-w-2xl px-4 md:px-6 py-16 md:py-24 text-center">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-teal/15 text-brand-teal text-3xl font-bold">
          ✓
        </div>
        <h1 className="mt-6 text-[28px] md:text-[34px] font-bold text-brand-navy">
          Thank you for applying
        </h1>
        <p className="mt-4 text-[16px] text-brand-mute leading-relaxed">
          {track === "advisor"
            ? "Your advisor application has been received and saved. A member of the GSG team will review your details and reach out if there is a fit."
            : track === "mentor"
              ? "Your mentor application has been received and saved. A member of the GSG team will review your details and reach out if there is a fit."
              : "Your application has been received and saved for both the advisor and mentor tracks. A member of the GSG team will review your details and reach out if there is a fit."}{" "}
          In the meantime, feel free to share this call with anyone in your
          network who could help.
        </p>
        <a
          href="https://www.gazaskygeeks.com"
          className="mt-8 inline-block text-brand-teal underline"
        >
          Back to gazaskygeeks.com
        </a>
      </div>
    </div>
  );
}
